import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/notification-monitoring', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const notificationTypes = (Options = {}) => {
  return httpClient
    .get('/api/notification-monitoring/types', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  notificationTypes
}
